
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { themes } from 'mdx-deck'

import {Header} from 'mdx-deck'
export const theme = themes.swiss;
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Next.js at Vercel`}</h1>
    <hr></hr>
    <h1>{`Next.js at Vercel`}</h1>
    <h2>{`How does Vercel use Next.js?`}</h2>
    <hr></hr>
    <h1>{`What are we going to learn?`}</h1>
    <hr></hr>
    <h1>{`What are we going to learn?`}</h1>
    <h2>{`1️⃣  How to be fast`}</h2>
    <hr></hr>
    <h1>{`What are we going to learn?`}</h1>
    <h2>{`1️⃣  How to be fast`}</h2>
    <h2>{`2️⃣ How to not re-invent the wheel`}</h2>
    <hr></hr>
    <h1>{`What are we going to learn?`}</h1>
    <h2>{`1️⃣  How to be fast`}</h2>
    <h2>{`2️⃣ How to not re-invent the wheel`}</h2>
    <h2>{`3️⃣ How to give users the optimal experience`}</h2>
    <hr></hr>
    <h2>{`tl;DR?`}</h2>
    <hr></hr>
    <h2>{`tl;DR?`}</h2>
    <h2>{`1️⃣  Use Jamstack`}</h2>
    <hr></hr>
    <h2>{`tl;DR?`}</h2>
    <h2>{`1️⃣  Use Jamstack`}</h2>
    <h2>{`2️⃣  Use React and React hooks`}</h2>
    <hr></hr>
    <h2>{`tl;DR?`}</h2>
    <h2>{`1️⃣  Use Jamstack`}</h2>
    <h2>{`2️⃣  Use React and React hooks`}</h2>
    <h2>{`3️⃣  One Next.js app to rule them all`}</h2>
    <hr></hr>
    <h1>{`Tools are flexible`}</h1>
    <hr></hr>
    <h1><em parentName="h1">{`Especially`}</em>{` web tools`}</h1>
    <h2><img src="https://i.imgur.com/lowwqNz.png" style={{
        maxWidth: '60%',
        marginTop: '-150px'
      }} /></h2>
    <hr></hr>
    <h1>{`React at Facebook is…`}</h1>
    <hr></hr>
    <h1>{`React at Facebook is…`}</h1>
    <h2>{`…unlike React at `}<inlineCode parentName="h2">{`\${anywhereElse}`}</inlineCode></h2>
    <hr></hr>
    <h1>{`Next.js is `}<em parentName="h1">{`powerful`}</em></h1>
    <hr></hr>
    <h1>{`Next.js is `}<em parentName="h1">{`powerful`}</em></h1>
    <h2>{`💪`}</h2>
    <hr></hr>
    <h1>{`Not trying to brag`}</h1>
    <hr></hr>
    <h1>{`Not trying to brag`}</h1>
    <h2>{`It's `}<em>{`strictly`}</em>{`, `}<em>{`definitionally`}</em>{` powerful`}</h2>
    <hr></hr>
    <h1>{`Next.js lets you run code at `}<em parentName="h1">{`every stage`}</em></h1>
    <hr></hr>
    <h1>{`Next.js lets you run code at `}<em parentName="h1">{`every stage`}</em></h1>
    <h2>{`Compile time, page generation time, server runtime, client runtime...`}</h2>
    <hr></hr>
    <h1>{`Great power`}</h1>
    <hr></hr>
    <h1>{`Great power → Great responsibility`}</h1>
    <hr></hr>
    <h1>{`Power can make us `}<em parentName="h1">{`slow`}</em></h1>
    <hr></hr>
    <h1>{`Power can make us `}<em parentName="h1">{`infinite slow (halt)`}</em></h1>
    <h2><a parentName="h2" {...{
        "href": "https://en.wikipedia.org/wiki/Halting_problem"
      }}>{`https://en.wikipedia.org/wiki/Halting_problem`}</a></h2>
    <hr></hr>
    <h1>{`Our priorities at Vercel`}</h1>
    <hr></hr>
    <h1>{`Our priorities at Vercel`}</h1>
    <h2>{`1️⃣  The customer`}</h2>
    <hr></hr>
    <h1>{`Our priorities at Vercel`}</h1>
    <h2>{`1️⃣  The customer`}</h2>
    <h2>{`🎉 That's it`}</h2>
    <hr></hr>
    <h1>{`Our `}<em parentName="h1">{`technical`}</em>{` priorities`}</h1>
    <hr></hr>
    <h1>{`Our `}<em parentName="h1">{`technical`}</em>{` priorities`}</h1>
    <h2>{`1️⃣  Security`}</h2>
    <hr></hr>
    <h1>{`Our `}<em parentName="h1">{`technical`}</em>{` priorities`}</h1>
    <h2>{`1️⃣  Security`}</h2>
    <h2>{`2️⃣  Availability`}</h2>
    <hr></hr>
    <h1>{`Our `}<em parentName="h1">{`technical`}</em>{` priorities`}</h1>
    <h2>{`1️⃣  Security`}</h2>
    <h2>{`2️⃣  Availability`}</h2>
    <h2>{`3️⃣  Performance`}</h2>
    <hr></hr>
    <h1>{`Our `}<em parentName="h1">{`technical`}</em>{` priorities`}</h1>
    <h2>{`1️⃣  Security`}</h2>
    <h2>{`2️⃣  Availability`}</h2>
    <h2>{`3️⃣  Performance`}</h2>
    <h2>{`4️⃣ DX / Feature-richness`}</h2>
    <hr></hr>
    <h1>{`Our `}<em parentName="h1">{`technical`}</em>{` priorities`}</h1>
    <h2>{`1️⃣  Security → Jamstack`}</h2>
    <h2>{`2️⃣  Availability → Jamstack`}</h2>
    <h2>{`3️⃣  Performance → Jamstack`}</h2>
    <h2>{`4️⃣ DX / Feature-richness`}</h2>
    <hr></hr>
    <h1>{`Our `}<em parentName="h1">{`technical`}</em>{` priorities`}</h1>
    <h2>{`1️⃣  Security → Jamstack`}</h2>
    <h2>{`2️⃣  Availability → Jamstack`}</h2>
    <h2>{`3️⃣  Performance → Jamstack`}</h2>
    <h2>{`4️⃣ DX / Feature-richness  → Next.js`}</h2>
    <hr></hr>
    <h1>{`Strategy: get rid of all the code`}</h1>
    <h2><img src="https://i.imgur.com/VqiRlwG.png" style={{
        maxWidth: '60%',
        marginTop: '-150px'
      }} /></h2>
    <hr></hr>
    <h1>{`Strategy: get rid of all the code`}</h1>
    <hr></hr>
    <h1>{`Strategy: get rid of all the code`}</h1>
    <h2>{`1️⃣ Delete code`}</h2>
    <hr></hr>
    <h1>{`Strategy: get rid of all the code`}</h1>
    <h2>{`1️⃣ Delete code`}</h2>
    <h2>{`2️⃣ Run less code`}</h2>
    <hr></hr>
    <h1>{`Strategy: get rid of all the code`}</h1>
    <h2>{`1️⃣ Delete code`}</h2>
    <h2>{`2️⃣ Run less code`}</h2>
    <h2>{`3️⃣ Try running the code at build time`}</h2>
    <hr></hr>
    <h1>{`Strategy: get rid of all the code`}</h1>
    <h2>{`1️⃣ Delete code`}</h2>
    <h2>{`2️⃣ Run less code`}</h2>
    <h2>{`3️⃣ Try running the code at build time`}</h2>
    <h2>{`4️⃣ If you really have to, run it on the client-side`}</h2>
    <hr></hr>
    <h1>{`Strategy: `}<span style={{
        color: 'blue'
      }}>{`💡 Jamstack`}</span></h1>
    <h2>{`1️⃣ Delete code`}</h2>
    <h2>{`2️⃣ Run less code`}</h2>
    <h2>{`3️⃣ Try running the code at build time`}</h2>
    <h2>{`4️⃣ If you really have to, run it on the client-side`}</h2>
    <hr></hr>
    <h1>{`Concretely…`}</h1>
    <hr></hr>
    <h1>{`Concretely…`}</h1>
    <h2>{`🟥 SSR (code) → ✅ HTML (no code!)`}</h2>
    <hr></hr>
    <h1>{`Concretely…`}</h1>
    <h2>{`🟥 SSR (code) → ✅ HTML (no code!)`}</h2>
    <h2>{`🟥 CSS-in-JS (code) → ✅ CSS (no code!)`}</h2>
    <hr></hr>
    <h1>{`Concretely…`}</h1>
    <h2>{`🟥 SSR (code) → ✅ HTML (no code!)`}</h2>
    <h2>{`🟥 CSS-in-JS (code) → ✅ CSS (no code!)`}</h2>
    <h2>{`🟥 Themes (code) → ✅ CSS Variables (no code!)`}</h2>
    <hr></hr>
    <h1>{`Concretely…`}</h1>
    <h2>{`🟥 SSR (code) → ✅ HTML (no code!)`}</h2>
    <h2>{`🟥 CSS-in-JS (code) → ✅ CSS (no code!)`}</h2>
    <h2>{`🟥 Themes (code) → ✅ CSS Variables (no code!)`}</h2>
    <h2>{`🟥 State mgmt lib → ✅ No state mgmt lib (no code!)`}</h2>
    <hr></hr>
    <h1>{`Concretely…`}</h1>
    <h2>{`🟥 SSR (code) → ✅ HTML (no code!)`}</h2>
    <h2>{`🟥 CSS-in-JS (code) → ✅ CSS (no code!)`}</h2>
    <h2>{`🟥 Themes (code) → ✅ CSS Variables (no code!)`}</h2>
    <h2>{`🟥 State mgmt lib → ✅ No state mgmt lib (no code!)`}</h2>
    <h2>{`🟥 Data fetching client → ✅ `}<inlineCode parentName="h2">{`fetch`}</inlineCode>{` (no code!)`}</h2>
    <hr></hr>
    <h1>{`Concretely…`}</h1>
    <h2>{`🟥 SSR (code) → ✅ HTML (no code!)`}</h2>
    <h2>{`🟥 CSS-in-JS (code) → ✅ CSS (no code!)`}</h2>
    <h2>{`🟥 Themes (code) → ✅ CSS Variables (no code!)`}</h2>
    <h2>{`🟥 State mgmt lib → ✅ No state mgmt lib (no code!)`}</h2>
    <h2>{`🟥 Data fetching client → ✅ `}<inlineCode parentName="h2">{`fetch`}</inlineCode>{` (no code!)`}</h2>
    <h2>{`🟥 Fancy combobox → ✅ `}<inlineCode parentName="h2">{`<select>`}</inlineCode>{` (no code!)`}</h2>
    <hr></hr>
    <h1>{`tl;DR: Use the platform`}</h1>
    <hr></hr>
    <h1>{`tl;DR: Use the platform`}</h1>
    <h2>{`✅ Web platform`}</h2>
    <hr></hr>
    <h1>{`tl;DR: Use the platform`}</h1>
    <h2>{`✅ Web platform`}</h2>
    <h2>{`✅ React platform`}</h2>
    <hr></hr>
    <h1>{`From SSR to SSG`}</h1>
    <hr></hr>
    <h1>{`From SSR to SSG`}</h1>
    <h2>{`Compute every  time → Compute once and share`}</h2>
    <hr></hr>
    <h1>{`From SSR to SSG`}</h1>
    <h2>{`Compute every  time → Compute once and share`}</h2>
    <h2>{`Region → Edge`}</h2>
    <hr></hr>
    <h1>{`From SSR to SSG`}</h1>
    <h2>{`Compute every  time → Compute once and share`}</h2>
    <h2>{`Region → Edge`}</h2>
    <h2>{`How? `}<inlineCode parentName="h2">{`getInitialProps`}</inlineCode>{` → `}<inlineCode parentName="h2">{`getStaticProps`}</inlineCode></h2>
    <hr></hr>
    <h1>{`From CSS-in-JS to CSS`}</h1>
    <hr></hr>
    <h1>{`From CSS-in-JS to CSS`}</h1>
    <h2>{`How? `}<inlineCode parentName="h2">{`import {a} from './css'`}</inlineCode>{` (Next.js 9.2)`}</h2>
    <hr></hr>
    <h1>{`From Themes to CSS Variables`}</h1>
    <hr></hr>
    <h1>{`From Themes to CSS Variables`}</h1>
    <h2>{`No `}<inlineCode parentName="h2">{`Context`}</inlineCode>{`, no new components`}</h2>
    <hr></hr>
    <h1>{`From Themes to CSS Variables`}</h1>
    <h2>{`No `}<inlineCode parentName="h2">{`Context`}</inlineCode>{`, no new components`}</h2>
    <h2>{`How? `}<inlineCode parentName="h2">{`var(--color-main)`}</inlineCode></h2>
    <hr></hr>
    <h1>{`From SSR to client-side data fetching`}</h1>
    <hr></hr>
    <h1>{`From SSR to client-side data fetching`}</h1>
    <h2>{`Why? No more servers!`}</h2>
    <hr></hr>
    <h1>{`From SSR to client-side data fetching`}</h1>
    <h2>{`Why? No more servers!`}</h2>
    <h2>{`When? User personalized / private data`}</h2>
    <hr></hr>
    <h1>{`From SSR to client-side data fetching`}</h1>
    <h2>{`Why? No more servers!`}</h2>
    <h2>{`When? User personalized / private data`}</h2>
    <h2>{`At build time with `}<inlineCode parentName="h2">{`fetch`}</inlineCode></h2>
    <hr></hr>
    <h1>{`From SSR to client-side data fetching`}</h1>
    <h2>{`Why? No more servers!`}</h2>
    <h2>{`When? User personalized / private data`}</h2>
    <h2>{`At build time with `}<inlineCode parentName="h2">{`fetch`}</inlineCode></h2>
    <h2>{`At run time with `}<inlineCode parentName="h2">{`fetch`}</inlineCode>{` and `}<inlineCode parentName="h2">{`SWR`}</inlineCode></h2>
    <hr></hr>
    <h1>{`Enter SWR (`}<a parentName="h1" {...{
        "href": "https://swr.now.sh"
      }}>{`https://swr.now.sh`}</a>{`)`}</h1>
    <pre><code parentName="pre" {...{}}>{`const { data, error } = useUser()
return <div>
  data === undefined?
    'Loading…':
    data ? \`Logged in as \${data.name}\`
         : Please log in!
</div>
`}</code></pre>
    <hr></hr>
    <h1>{`Enter SWR (`}<a parentName="h1" {...{
        "href": "https://swr.now.sh"
      }}>{`https://swr.now.sh`}</a>{`)`}</h1>
    <pre><code parentName="pre" {...{}}>{`const { data, error } = useUser() // <--- REENTRANT!
return <div>
  data === undefined?
    'Loading…':
    data ? \`Logged in as \${data.name}\`
         : Please log in!
</div>
`}</code></pre>
    <hr></hr>
    <h1>{`Enter SWR (`}<a parentName="h1" {...{
        "href": "https://swr.now.sh"
      }}>{`https://swr.now.sh`}</a>{`)`}</h1>
    <h2>{`✅ Consistent user experience`}</h2>
    <hr></hr>
    <h1>{`Enter SWR (`}<a parentName="h1" {...{
        "href": "https://swr.now.sh"
      }}>{`https://swr.now.sh`}</a>{`)`}</h1>
    <h2>{`✅ Consistent user experience`}</h2>
    <h2>{`✅ No global store`}</h2>
    <hr></hr>
    <h1>{`Enter SWR (`}<a parentName="h1" {...{
        "href": "https://swr.now.sh"
      }}>{`https://swr.now.sh`}</a>{`)`}</h1>
    <h2>{`✅ Consistent user experience`}</h2>
    <h2>{`✅ No global store`}</h2>
    <h2>{`✅ Code looks "sync"`}</h2>
    <hr></hr>
    <h1>{`Enter SWR (`}<a parentName="h1" {...{
        "href": "https://swr.now.sh"
      }}>{`https://swr.now.sh`}</a>{`)`}</h1>
    <h2>{`✅ Consistent user experience`}</h2>
    <h2>{`✅ No global store`}</h2>
    <h2>{`✅ Code looks "sync"`}</h2>
    <h2>{`✅ Works with any backend`}</h2>
    <hr></hr>
    <h1>{`Where do we go from here?`}</h1>
    <h2>{`1️⃣ Jamstack framework: `}<a parentName="h2" {...{
        "href": "https://nextjs.org/learn"
      }}>{`https://nextjs.org/learn`}</a></h2>
    <h2>{`2️⃣ Jamstack edge platform: `}<a parentName="h2" {...{
        "href": "https://vercel.com"
      }}>{`https://vercel.com`}</a></h2>
    <h2>{`3️⃣ Jamstack tweets: `}<a parentName="h2" {...{
        "href": "https://twitter.com/@rauchg"
      }}>{`https://twitter.com/@rauchg`}</a></h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;